import { api } from "@/lib/api";

export const clientApi = {
  listRoutes: (params) => api.get("/api/rutas", { params }),
  getRoute: (routeId) => api.get(`/api/rutas/${routeId}`),
  listDepartures: (routeId, params) => api.get(`/api/rutas/${routeId}/salidas`, { params }),
  getSeatLayout: (capacity) => api.get(`/api/asientos/layout/${capacity}`),

  createReservation: (payload) => api.post("/api/cliente/reservas", payload),
  listReservations: () => api.get("/api/cliente/reservas"),
  getReservation: (id) => api.get(`/api/cliente/reservas/${id}`),
  cancelReservation: (id, reason) => api.put(`/api/cliente/reservas/${id}/cancelar`, { reason }),
  createReview: (reservationId, payload) => api.post(`/api/cliente/reservas/${reservationId}/resena`, payload),

  getRatings: () => api.get("/api/cliente/calificaciones"),

  listAddresses: () => api.get("/api/cliente/direcciones"),
  createAddress: (payload) => api.post("/api/cliente/direcciones", payload),
  updateAddress: (id, payload) => api.put(`/api/cliente/direcciones/${id}`, payload),
  deleteAddress: (id) => api.delete(`/api/cliente/direcciones/${id}`),

  listPaymentMethods: () => api.get("/api/cliente/metodos-pago"),
  createPaymentMethod: (payload) => api.post("/api/cliente/metodos-pago", payload),
  updatePaymentMethod: (id, payload) => api.put(`/api/cliente/metodos-pago/${id}`, payload),
  deletePaymentMethod: (id) => api.delete(`/api/cliente/metodos-pago/${id}`),
};

export default clientApi;
